import React from "react";
import { Button, Input } from "../ui";
import LudDashboardModal from "./LudDashboardModal";
import { useSubmitGuard } from "./modalHooks";
import "./PlatformLinksModal.css";

export default function PlatformLinksModal({
  open,
  lang,
  text,
  links = [],
  onChange,
  onAdd,
  onClose,
  onSave,
}) {
  // Repeat clicks are ignored while a save returned by the caller is running.
  const [saving, runSave] = useSubmitGuard();
  return (
    <LudDashboardModal
      open={open}
      busy={saving}
      title={lang === "ar" ? "إدارة روابط المنصات" : "Manage Platform Links"}
      onClose={onClose}
      footer={
        <>
          <Button
            variant="primary"
            appearance="filled"
            disabled={saving}
            loading={saving}
            onClick={() => runSave(onSave)}
          >
            {text.save}
          </Button>

          <Button
            variant="danger"
            appearance="soft"
            onClick={onClose}
          >
            {text.cancel}
          </Button>
        </>
      }
    >
      <div className="platform-links-modal">
        <div className="platform-links-modal-list">
          {links.map((item, index) => (
            <div
              className="platform-links-modal-row"
              key={`${item.app}-${index}`}
            >
              <Input
                label={lang === "ar" ? "التطبيق" : "Application"}
                value={item.app}
                onChange={(event) =>
                  onChange(index, "app", event.target.value)
                }
              />

              <Input
                label={text.platformLink}
                value={item.url}
                onChange={(event) =>
                  onChange(index, "url", event.target.value)
                }
              />
            </div>
          ))}

          <div className="platform-links-modal-add">
            <Button
              type="button"
              size="sm"
              appearance="soft"
              onClick={onAdd}
            >
              {lang === "ar"
                ? "+ إضافة رابط منصة"
                : "+ Add Platform Link"}
            </Button>
          </div>
        </div>
      </div>
    </LudDashboardModal>
  );
}
